import { IconName, ActionToolbarButton } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { PortfolioCentralProductOverviewEntry } from '@mews-commander/data-access';
import { useDeleteCentralProductDialog } from '../../../hooks/useDeleteCentralProductDialog';
import { BulkActionToolbar } from '../../_shared/BulkActionToolbar';
import { BulkAddToProperty } from './BulkAddToProperty';

interface Props {
    selectedRows: PortfolioCentralProductOverviewEntry[];
    resetRowSelection: () => void;
}

export const BulkActions = ({ selectedRows, resetRowSelection }: Props) => {
    const selectedRowsAmount = selectedRows.length;

    const centralProductIds = selectedRows.map(({ id }) => id);

    const assignedPropertyIds = selectedRows?.flatMap(({ propertyIds }) => propertyIds).length;

    const { confirmationDialog, openConfirmationDialog } = useDeleteCentralProductDialog({
        centralProductIds,
        propertyIdsLength: assignedPropertyIds,
        onSuccess: resetRowSelection,
    });

    return (
        <BulkActionToolbar
            selectedRows={selectedRowsAmount}
            resetRowSelection={resetRowSelection}
            rightSide={
                <>
                    <BulkAddToProperty
                        productId={selectedRows[0]?.id}
                        isDisabled={!selectedRowsAmount || selectedRowsAmount > 1}
                        // At this moment we are enabling bulkAdd only to one product
                        propertyIds={selectedRows[0]?.propertyIds}
                    />
                    <ActionToolbarButton
                        icon={IconName.Delete}
                        disabled={!selectedRowsAmount}
                        onClick={openConfirmationDialog}
                    >
                        {lt('Delete')}
                    </ActionToolbarButton>
                    {confirmationDialog}
                </>
            }
        />
    );
};
